 <template>  
 <div>
 <div class="top-bar clear">
  <div class="container">
  <div class="Page-nav">
	<!--繁简体-->
   <div class="LangDiv">
    <a  :class='{active:!isLang}'  @click="changeIsLang(false)">{{isLang?'簡體':'简体'}}</a> | 
	<a :class='{active:isLang}' @click="changeIsLang(true)">{{isLang?'繁體':'繁体'}}</a> 
  </div> 
  <!--登录-->
  <div class="loginDiv clear"> 
	<span @click="navhref('/','')" class="pointer">首{{isLang?'頁':'页'}}</span><span class="cf9">|</span>
	<!--IP登录
    <span v-if="isIpLogin">ip<span class="cf9">|</span></span> -->
	<!--密码登录--> 
	<div  v-if='userInfo.LoginState!=0'  class="pwdLoginDiv fr"  >
    <span class="" >用{{isLang?'戶':'户'}}名：</span>
	 <input type="text"  class="" @keydown.enter="handleLoginEnter('Pwd')" v-model="form.userNo"/> 
	<span class="">密{{isLang===true?'碼':'码'}}：</span>
	<input type="password" ref="refPwd" class="" @keydown.enter="handleLoginEnter('Code')" v-model="form.userPwd"/> 
	<span class="" >{{isLang===true?'驗證碼':'验证码'}}：</span>
	<input type="text" ref="refCode" class=" textcode"@keydown.enter="handleLoginEnter('Login')"  v-model="form.code"/> 
     <span > 
		  <Captcha ref="captchaRef" @getValue="getValue" width="80" style="margin-top: 15px;"></Captcha>
</span>
     <span class="chLogin" @click="changLogin" style="margin-left: 5px;">登{{isLang===true?'錄':'录'}}</span>
	</div>  
	 
	  <span v-if='userInfo.LoginState==0'><a v-if='userInfo.userInfo.state==0' class='syh'>试用户：</a>{{userInfo.userInfo.UserName}}</span>
  </div>
  </div></div>
  </div>
  
  <!--导航栏-->
  <div class="header">
  	  <div class="container">
  	  	  <div class=" header-wrapper clear">
  	  	                  <div class="logo fl">
  	  	                      <a @click="navhref('/','')"> 
  	  	                          <img src="../assets/images/rzelogo.png">
  	  	                      </a>
  	  	                  </div> 
  	  	                 <div  class="ify-item fr">
							 <ul v-if="navList.length>0">
						 <li class="nav-item "  :class="{dropdown: item.items?.length>0}" v-for="(item,index) in navList" :key="index">
							 
							 <a @click="navhref(item.urlCode,item.navCode)"><span v-if="!isLang">{{item.navName}}</span><span v-else>{{item.L_navName}}</span></a>
							 <ul v-if="item.items?.length>0" id="nav-zt" >
							   <li class="nav-item" v-for="(li,index) in item.items" :key="index"><a><span v-if="!isLang">{{li.navName}}</span><span v-else>{{li.L_navName}}</span></a></li>
							 </ul>
							 </li>
							 </ul>
						 </div>
  	  	              </div>
  	  	  </div>
  	  </div>
	  </div> 
	  </div>
	  </template>  
      <script> 
 import Captcha from '../components/Captcha.vue';
import publicsearch from '../assets/css/publicsearch.css'; 
 import {  Indicator,MessageBox } from "mint-ui";
export default {
    components:{
     'Captcha':Captcha
	},
    name : "Navbar",
    data() {
    return {
		form:{  
        userNo:"",
         userPwd:"", 
		 code:'',
        }, 
    tyCode:'ZH', 
    isLang:false,
    LoginWay:"IP",//登录方式，默认IP
	userInfo:[],//用户信息
	navList:[],
	loginResult:[],
	VCode:"",//验证码Code
	Uid:"",
	}
  },  
  watch:{ 
	
  },
  mounted() { 
	//  this.getIP();
	  this.init();
	  
  },
  methods: {
	  changeIsLang(Lang){//更改繁简体
	  	this.isLang=Lang;  
		sessionStorage.setItem("#isLang",JSON.stringify(Lang) );
		this.$emit('handle-isLang');
	   //location.reload();
	  },
     async getValue(val){ 
		 this.VCode=val; 
     },
	    changLogin(){
		this.LoginWay="Pwd";
		 this.login(); 
	 } , 
	 Rlogin(){
		 this.LoginWay="IP";
		 this.login();
	 },
	 
	 handleLoginEnter(code){ 
		 
		 if(code=="Pwd"){
			 this.$refs.refPwd.focus();
		 }else if(code=="Code")
		 {
			 this.$refs.refCode.focus();
			 
		 }
		 else if(code=="Login"){
			 
			 this.LoginWay="Pwd";
			 this.login();
		 }
	 },
	 
	 //初始化
	 init(){   
		 if(this.$route.query.Uid&&this.utils.isMobile()){//&&this.utils.isMobile()
		   this.LoginWay="Uid";
		   this.Uid=this.$route.query.Uid;
		 }
		  //简繁体 
		 let s_isLang =JSON.parse(sessionStorage.getItem("#isLang")); 
		 if(s_isLang==null){s_isLang=false;}  
		 this.isLang= s_isLang;  
		 this.NavInfo(); 
		 let userInfo=this.utils.getssionStorageWithExpiry("#UserInfo")||"";
       if ( userInfo=="") {
       this.login();
       }
	   else
	   { 
	   this.userInfo=JSON.parse(userInfo);  
	   } 
	    sessionStorage.setItem("#Token",this.userInfo.Token);
	 },
	 async getIP(){ 
		 try {
		 	     let userIp = sessionStorage.getItem("#userIP") || "";  
				 if(userIp==""){ 
		 				let params={};
					 let  res=await this.$http.GetIP(params);
					 console.log('res',res)
					 sessionStorage.setItem("#userIP",res.ip); 
				 } 
		 } catch (error) {
			 console.log("errpr",error)
		 	//TODO handle the exception
		 }		
     
	 },
	   async login() {//登录 
		   try { 
	    if(this.LoginWay=="IP"){
			let ip=sessionStorage.getItem("#userIP")||"";
			 if(ip==""){
				 let params={};
				 let  res=await this.$http.GetIP(params); 
				 sessionStorage.setItem("#userIP",res.ip); 
			 }
		}else if(this.LoginWay=="Pwd"){ 
			if(!this.form.userNo){ 
				throw new Error("请输入用户名");
			}
			
			if(!this.form.userPwd){
				throw new Error("请输入密码"); 
			}
			if(!this.form.code){
				throw new Error("请输入验证码"); 
			}
			if(this.form.code!=this.VCode){  
				throw new Error("验证码错误!"); 
			}
			
		}  
		    let params = {
		    	tyCode: this.tyCode,
		    	isLang:this.isLang,
				LoginWay:this.LoginWay,
				userNo:this.form.userNo,
				userPwd:this.form.userPwd,
				ip:sessionStorage.getItem("#userIP"),
				Uid:this.Uid
		    };     
		     let  res=await this.$http.Login(params);      
			 this.userInfo=res.loginResult;   
			 if(this.LoginWay=="Pwd"&& this.userInfo.LoginState==-1){  
				  throw new Error(this.userInfo.LoginMessage.Message); 
			 }
			 if(this.userInfo.LoginState!=-1){
			 this.utils.setSessionStorageWithExpiry("#UserInfo",JSON.stringify(this.userInfo),1); 
			  }
		   } catch (error) {
			   const message=error.message||"";
			   if(message!=""){
				   
				   				  MessageBox.alert(error.message,"提示"); 
			   }
				this.$refs.captchaRef.generateCaptcha();
		   }
	   },
    async  NavInfo(){  
		 try {	
			 let resNavInfo=sessionStorage.getItem("#NavInfo") || "";
			 if(resNavInfo!=""){
				this.navList= JSON.parse(resNavInfo);
			 }
		 else{
		 	let params = {
				tyCode:this.tyCode,
				isLang:this.isLang
			}; 
			console.log(params)
			  let res=await this.$http.NavInfo(params);   
			 sessionStorage.setItem("#NavInfo",JSON.stringify(res.navInfo));
			   this.navList=res.navInfo; 
			  }
			  // 存储布尔值
			   console.log()
			 
		 } catch (error) {
		 	//TODO handle the exception
		 }		
		 
	 }
	 ,
	 async navhref(urlCode,navCode){  
		  localStorage.removeItem('formData');
		  localStorage.removeItem('informData');
	   if(urlCode=="/"){ 
		     this.$router.push("/indexPage");
	   }
	   else{ 
		   // const { path } = this.$route; // 获取当前路由的路径
		 this.$router.push({ name: urlCode, params: { ifyCode: navCode}})}
		//this.$router.push({ name:urlCode, params: { ifyCode: navCode } });
	 },

  }
}
</script>
 <style>
	 .pwdLoginDiv{
		 display: flex ;
		     align-items: center;
		     height: 42px; 
		 input,span{
			 display:block;
			 float: left;
		 }
	 		input{margin:0px  5px;
	  width: 140px;
	 	  
	 	
	 	 }
	 	 input.textcode{width: 60px;}
		 .chLogin{
			 cursor: pointer;
		 }
	 	.capclass{  
	 		width: 80px;height: 20px;  
}	 	 
	 	
	 	}
	 #top-bar {
	     min-height: 40px;
	     line-height: 40px;
	     width: 100%;
	     border-bottom: 1px solid #eee;
	     text-align: right;
	 }
	 
	     #top-bar span {
	         vertical-align: top;
	         margin: 0px 5px;
	         color: #999;
	     }
	 
	 .LangDiv {
	     float: left;
	 }
	 
	     .LangDiv a.active {
	         color: #9b0202;
	     }
	 
	 .header {
	     width: 100%;
	     height: 100%;
	 }
	 
	 .header-wrapper {
	     position: relative;
	     height: 100px;
	     line-height: 100px;
	 }
	 .pointer{
		 cursor: pointer;
	 }
	 .logo {
	     max-width: 28%;
	 }
	 
	     .logo img {
	         vertical-align: middle;
	     }
	 
	 .divLogin {
	     float: right;
	 }
	 
	     .divLogin .passWord {
	         color: #0570f3;
	         text-decoration: underline;
	     }
	 
	     .divLogin label {
	         margin-right: 5px;
	     }
	 
	     .divLogin input {
	         margin-left: 10px;
	         width: 140px;
	     }
	 
	         .divLogin input.userCode {
	             width: 80px;
	         }
	 
	 .CodeImg {
	     margin-top: 10px;
	 }
	 
	     .CodeImg img {
	         width: 80px;
	         height: 20px;
	         vertical-align: middle;
	     }
	 
	 .divLogin a {
	     margin-left: 10px;
	 }
	 .syh{
		     vertical-align: top;
		     margin: 0px 5px;
		     color: #999;
			 font-size: 12px;
			 cursor:text;
	 }
	 @media screen and (max-width:960px) {
	     .logo
	     {
	         max-width:80%; 
	     }
	     .logo img
	     {
	         max-width:100%;
	         max-height:50px; 
	     }
	  
	     .header-wrapper
	 { 
	     height:70px;
	     line-height:70px;
	 }
	   
	     .menu-button  
	     {
	         padding:0px 15px;
	         display:block;
	         content:"";
	         width:31px;
	         height:70px; 
	         background:url(../assets/images/image/icon-menu.png) no-repeat center  center;
	     }
	     .menu-button.close
	     {
	         background-image:url(../assets/images/image/icon-close.png);
	     }
	        .ify-item
	     {
	         display:none; 
	         float:none;
	         right:-15px;
	         top:70px;
	         position:absolute;
	         width:300px; 
	          z-index:100000;
	          background-color:#efefef;
	          line-height:40px;
	         padding:0px 30px;
	     }
	     .ify-item.active
	     {
	         display:block;
	     }
	 .ify-item li a
	 {
	     
	        font-size:14px;
	           
	 }
	     .ify-item li.dropdown 
	     {
	         border-top:1px solid #999;
	         border-bottom:1px solid #999;
	     }
	     .ify-item li ul li a
	     {
	         font-size:13px;
	         padding:0px 30px;
	     }
	 }
	 @media screen and (max-width:481px)
	 {
	     .ify-item
	     {
	         width:200px;
	     }
	 }
	 
	 @media screen and (min-width:961px)
	 {
	     .ify-menu
	     {
	         display: none;
	     }
	 
	     .logo img
	     {
	         width: 100%;
	     }
	 
	     .ify-item ul li
	     {
	         float: left;
	         padding: 0px 30px 0px 0px;
	         position: relative;
	     }
	 
	     .ify-item li a
	     {
	         font-size: 16px;
	     }
	 
	     .ify-item li > ul > li > a
	     {
	         padding-top: 9.5px;
	         padding-bottom: 9.5px;
	     }
	 
	     .ify-item li > ul > li > a
	     {
	         display: block;
	         color: #252930;
	         font-size: 15px;
	         font-family: var(--thm-font);
	         word-break: break-all;
	         -webkit-transition: all 500ms ease;
	         transition: all 500ms ease;
	         width: 100%;
	     }
	 
	     .ify-item li.dropdown > a:first-child::after
	     {
	         content: "";
	         display: inline-block;
	         height: 12px;
	         width: 20px;
	         background: url(../assets/images/image/icon-dow.png) no-repeat center center;
	         margin-left: 5px;
	     }
	 
	     .ify-item li.nav-item:hover > ul
	     {
	         -webkit-transition: opacity 500ms ease,visibility 500ms ease,-webkit-transform 500ms ease;
	         transition: opacity 500ms ease,visibility 500ms ease,-webkit-transform 500ms ease;
	         -webkit-transition: opacity 500ms ease,visibility 500ms ease,-webkit-transform 500ms ease;
	         transition: opacity 500ms ease,visibility 500ms ease,-webkit-transform 500ms ease;
	         transition: transform 500ms ease,opacity 500ms ease,visibility 500ms ease;
	         transition: transform 500ms ease,opacity 500ms ease,visibility 500ms ease,-webkit-transform 500ms ease;
	         transition: transform 500ms ease,opacity 500ms ease,visibility 500ms ease,-webkit-transform 500ms ease;
	         -webkit-transform: perspective(300px) scaleY(1) translateZ(0);
	         transform: perspective(300px) scaleY(1) translateZ(0);
	         visibility: visible;
	         opacity: 1;
	     }
	 
	     .ify-item li ul
	     {
	         position: absolute;
	         width: 150px;
	         background-color: #fff;
	         border-top: 2px solid #252930;
	         box-shadow: 2px 2px 5px 1px rgba(0,0,0,.05), -2px 0 5px 1px rgba(0,0,0,.05);
	         -webkit-transform-origin: top;
	         transform-origin: top;
	         visibility: hidden;
	         opacity: 0;
	         z-index: 991;
	         line-height: 30px;
	     }
	 
	     .ify-item li > ul
	     {
	         right: 0;
	         -webkit-transform: perspective(300px) scaleY(0) translateZ(30px);
	         transform: perspective(300px) scaleY(0) translateZ(30px);
	         visibility: hidden;
	         opacity: 0;
	     }
	 
	     .ify-item li > ul > li
	     {
	         float: none;
	         padding: 0px 30px;
	     }
	 
	     #nav-zt li:after
	     {
	         content: "";
	         width: 0;
	         height: 2px;
	         background: #333;
	         position: absolute;
	         top: 100%;
	         left: 50%;
	         transition: all .8s;
	     }
	 
	     #nav-zt li:hover:after
	     {
	         left: 0%;
	         width: 100%;
	     }
	     /*#nav-zt li:hover
	     {
	         background-color:#e2e1e0;
	     }*/
	 }
	     @media screen and (max-width: 1200px)
	     {
	 
	         .container
	         {
	             padding: 0px 15px;
	         }
	     }
	 
	     @media (min-width:1201px)
	     {
	         .container
	         {
	             max-width: 1200px;
	         }
	 
	         .logo img
	         {
	             height: 75px;
	             width: auto;
	         }
	     }

 </style>